export const CRITERIA = {
  images: [
    { label: 'A clear picture', key: 'clear-picture' },
    { label: '*.JPG, *.PNG, or *.GIF formats', key: 'formats' },
    { label: 'An aspect ratio of 4:3', key: 'aspect-ratio' },
    { label: 'File size of up to 5 MB ', key: 'file-size' },
  ],
  video: [
    { label: 'Clear sound', key: 'clear-sound' },
    { label: 'Good lighting', key: 'good-lighting' },
    { label: 'An aspect ratio of 4:3', key: 'aspect-ratio' },
    { label: '*.mp4 or *.avi formats', key: 'format' },
    { label: 'You speaking fluently', key: 'speaking-fluently' },
    { label: 'Duration of up to 30 seconds long', key: 'duration-30' },
    { label: 'File size of up to 75 MB', key: 'file-size' },
    { label: 'Resolution of 720p or higher', key: 'resolution' },
  ],
}
export const MAX_UPLOADED_IMAGES = 5
export const MAX_UPLOADED_IMAGE_SIZE = 5242880

export const MAX_UPLOADED_IMAGE_SIZE_SMALL = 2097152
export const MAX_UPLOADED_VIDEO_SIZE = 78643200
export const MAX_UPLOADED_VIDEOS = 1
